import React from "react";
import { useQuery } from "@tanstack/react-query";
import { filterMatchParams } from "utils/common";
import { IMatchesApiCall, ISearchMatchesParams } from "utils/api.interfaces";
import axiosinterceptor from "../utils/api.interceptor";

const fetchFootballMatches = (
  params: ISearchMatchesParams
): Promise<IMatchesApiCall> => {
  return axiosinterceptor
    .get(`/v1/FootballMatches`, {
      params: filterMatchParams(params),
    })
    .then<IMatchesApiCall>((res) => res.data);
};
export default function useMatches(params: ISearchMatchesParams) {
  const queryMatches = useQuery(
    ["matches", params],
    () => fetchFootballMatches(params),
    {
      keepPreviousData: false,
    }
  );

  // const sortedByDate = queryMatches.data?.matches.sort(
  //   (obj1, obj2) =>
  //     // @ts-ignore
  //     new Date(obj1.scheduledAtUtc) - new Date(obj2.scheduledAtUtc)
  // );

  return {
    ...queryMatches,
    dataMatches: queryMatches.data,
    matchesIsLoading: queryMatches.isLoading,
  };
}
